import React from "react";
import { useTheme } from "./hooks/useTheme";

interface CardNumberValidateProps {
  value: string;
  setValue: (value: string) => void;
  className?: any;
}

const CardNumberValidate = ({
  value,
  setValue,
  className,
}: CardNumberValidateProps) => {
   const { themeStyles } = useTheme();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setValue(value);
    const isValid = /^\d{8,19}$/gm.test(value);
    e.target.setCustomValidity(
      isValid ? "" : "Please enter a valid card number"
    );
  };

  return (
    <>
      <label className={`block text-xs font-medium ${themeStyles.form.tailwindLabelTextColor} text-left`}>Card Number</label>
      <input
        name="cardnumber"
        type="text"
        className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
        required
        value={value}
        onChange={handleChange}
      />
    </>
  );
};

export default CardNumberValidate;
